<template>
  <div id="login_page" style="display: none">
    <div class="formContainer flex-mid fc-FFFFFF">
      <div class="divContainer2">
        <div style="padding: 52px 160px 0 160px">
          <div class="center">
            <img
              src="../assets/images/wv-monthly-insights/Icon.png"
              class="imgLogo p-11"
            />
          </div>
          <div class="fs-24 fw-800 mt-32">
            {{ $t("sso.your") }} <span class="fc-FBC02D">SSO</span>
          </div>
          <div v-if="authData.email" class="mt-24 fs-16">
            {{ $t("sso.this_account") }} ({{ authData.email }})
            {{ $t("sso.has_been_set") }}
          </div>
          <div v-if="false" class="mt-12">
            <div
              class="center fc-FFFFFF"
              style="
                height: 31px;
                width: 191px;
                background-color: white;
                border-radius: 4px;
                color: gray;
                padding-top: 11px;
              "
            >
              <span class="fw-900">APIs</span> {{ $t("sso.google_sign_In") }}
            </div>
          </div>

          <!-- Check that the SDK client is not currently loading before accessing is methods -->
          <div v-if="!loading">
            <div v-if="true || !user.email" class="mt-12" @click="login">
              <div
                class="center fc-FFFFFF"
                style="
                  height: 31px;
                  width: 191px;
                  background-color: white;
                  border-radius: 4px;
                  color: gray;
                  padding-top: 11px;
                "
              >
                <span class="fw-900">{{ $t("sso.sign_In") }}</span>
              </div>
            </div>
            <div v-if="user.email" class="mt-12" @click="logout">
              <div
                class="center fc-FFFFFF"
                style="
                  height: 31px;
                  width: 191px;
                  background-color: white;
                  border-radius: 4px;
                  color: gray;
                  padding-top: 11px;
                "
              >
                <span class="fw-900">{{ $t("sso.sign_Out") }}</span>
              </div>
            </div>
          </div>

          <div class="mt-40 pt-2">
            <el-button class="btnSignIn" type="primary" @click="goBack">{{
              $t("register.go_back")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import router from '@/router';
import format from 'date-fns/format';
import { getCompany } from '../store/core/cacheService'
export default {
  async created() {
    await this.login();
  },
  computed: {
    user() {
      return firebase.auth().currentUser || {};
    },
    authData() {
      return this.$store.getters["sso/authData"] || {};
    },
    autoLogin() {
      return this.$store.getters["sso/autoLogin"] || {};
    },
  },
  data() {
    return {
      loading: false,
      // user: {
      //   email: "tareef_j@dhas.com",
      // },
    };
  },
  methods: {
    // Log the user in
    async login() {
      const loginSsoId = this.$route.params.id;
      if (!loginSsoId) {
        router.replace('login');
        return;
      }

      const loginSsoData = (await firebase.database().ref(`/loginsso/${loginSsoId}`).once('value')).val();
      if (!loginSsoData) {
        router.replace('login');
        return;
      }

      const email = _.get(loginSsoData, "email", "");
      if (!email) {
        router.replace('login');
        return;
      }

      const emailKey = email.replace(/\./g, '||');
      const authData = {
        email: email,
      }

      firebase.auth().signInWithEmailAndPassword(email, "happily_2018").then(async (res) => {
        let user = null;
        let userReal = null;
        if(emailKey){
          userReal = (await firebase.database().ref(`/users/${emailKey}`).once('value')).val();
        }
        if(userReal){
          user = userReal
        }else{
          const userAdviser = (await firebase.database().ref(`/users_adviser/${emailKey}`).once('value')).val();
          if(userAdviser){
            user = userAdviser
          }
        }
        
        if(!user){
          firebase.auth().signOut();
          reouter.replace('login');
          return;
        }

        const company = await getCompany(user.company)
        const user2 = {
          company_name:company.name,
          company:user.company,
          firstname:user.firstname,
          lastname:user.lastname,
          user_type:user.user_type,
          email:user.email,
          profilepic:(user.profilepic)?user.profilepic:'',
          profilepic_crop:(user.profilepic_crop)?user.profilepic_crop:'',
          profilepic_small:(user.profilepic_small)?user.profilepic_small:'',
          team:(user.team)?user.team:'',
        }

        this.$store.commit("authen/setUserLogin", user2, {root: true});

        localStorage.setItem('userVersion',await (await firebase.database().ref(`version/my_version`).once("value")).val());
        localStorage.setItem('userData', btoa(encodeURIComponent(JSON.stringify(user2))));

        /*save logs*/
        this.$store.dispatch('authen/addLogs', {
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          status: 'login',
          user: user.email
        }, {root:true}).then(function() {
          setTimeout(() => {
            console.log("setTimeout()");
            if (user.user_type == 'admin') {
              router.replace('/members')  
            } else if(user.user_type == 'developer'){
              router.replace('/integrations')  
            }else if(authData.freetrial){
              router.replace('/setup-wizard')  
            } else{
              router.replace('/')
            }
            this.$store.commit('authen/loadingStatus', false, { root: true });
          }, 500);
        });

      });
    },
    // Log the user out
    logout() {
      // console.log("logout()");
      const authData = this.$store.getters["sso/authData"];
      // this.$store.dispatch("sso/logout", authData);

      this.$store.dispatch("auth/logout", authData, {root: true})

      // this.$sso.logout({
      //   returnTo: window.location.origin + "/sso-login",
      // });
    },
    submitForm() {
      console.log("submitForm"); // TODO: ....
    },
    goBack() {
      this.$router.push('login');
    },
  },
};
</script>

<style lang="scss" scoped>
.formContainer {
  min-height: 100vh;
  height: calc(100vh);
  background-color: #6c30cc;
}
.divContainer2 {
  width: 640px;
  min-height: 600px;
  background: rgba($color: #111111, $alpha: 0.12);
  border-radius: 4px;
  transition: 0.3s;
  margin: auto;
}
.imgLogo {
  width: 64px;
  height: 64px;
}
.btnSignIn {
  width: 100%;
  height: 50px;
  font-size: 20px;
  font-weight: 700;
  border-width: 0px;
  background-color: rgba($color: #ffffff, $alpha: 0.2);
  transition: 0.3s;
  &:hover {
    background-color: rgba($color: #ffffff, $alpha: 0.22);
  }
}
</style>
